import { map } from 'underscore';
import { createOrUpdateListingGroup } from '@bingads-webui-campaign-react/perf-max-data';
import { Model$ListingGroup } from '../ApiType';
import { NullPartial, } from '../constant';

interface UpdateListingTreePayload {
  ListingGroupsToAdd: Partial<NullPartial<Model$ListingGroup>>[];
  ListingGroupsToDelete: number[];
  AssetGroupId: number,
}

// edit tree view
export async function updateListingTree(payload: UpdateListingTreePayload) {
  const { ListingGroupsToAdd, ListingGroupsToDelete, AssetGroupId } = payload;
  const itemsToAdd = ListingGroupsToAdd;
  const itemsToDelete = map(ListingGroupsToDelete, id => ({
    Id: id,
    AssetGroupId,
    Status: 'Deleted',
  }));
  return createOrUpdateListingGroup(itemsToAdd, itemsToDelete).then(res => res).catch(e => e);
}

export async function createRootListingTree(assetGroupId: number) {
  const itemsToAdd = [{
    Id: -1,
    AssetGroupId: assetGroupId,
    IsLeaf: true,
    IsExcluded: false,
    Condition: {
      Operand: 'All',
      Attribute: '',
    },
  }];

  return createOrUpdateListingGroup(itemsToAdd, []);
}
